var map = {
	"./5defebrero": "6aa2",
	"./5defebrero.js": "6aa2",
	"./barrionuevo": "27d2",
	"./barrionuevo.js": "27d2",
	"./barriorojas": "bc38",
	"./barriorojas.js": "bc38",
	"./calacali": "0991",
	"./calacali.js": "0991",
	"./chillogallo": "4492",
	"./chillogallo.js": "4492",
	"./chullagol": "84be",
	"./chullagol.js": "84be",
	"./ciudadelaejercito": "2221",
	"./ciudadelaejercito.js": "2221",
	"./ciudadelahospitalaria": "3c80",
	"./ciudadelahospitalaria.js": "3c80",
	"./ciudadelamexico": "2fff",
	"./ciudadelamexico.js": "2fff",
	"./clementeballen": "21c8",
	"./clementeballen.js": "21c8",
	"./comite15denoviembre": "ea50",
	"./comite15denoviembre.js": "ea50",
	"./copaamistadiess": "39fe",
	"./copaamistadiess.js": "39fe",
	"./copaatahualpa": "a029",
	"./copaatahualpa.js": "a029",
	"./demo": "6382",
	"./demo.js": "6382",
	"./elitesport": "1b55",
	"./elitesport.js": "1b55",
	"./eloyalfaro": "9fdd",
	"./eloyalfaro.js": "9fdd",
	"./indorock": "173c",
	"./indorock.js": "173c",
	"./jveventosdeportivos": "abc0",
	"./jveventosdeportivos.js": "abc0",
	"./lalibertad": "8c93",
	"./lalibertad.js": "8c93",
	"./playgol": "4033",
	"./playgol.js": "4033",
	"./primerodemayocalzado": "a663",
	"./primerodemayocalzado.js": "a663",
	"./sanpedroysanpablo": "7818",
	"./sanpedroysanpablo.js": "7818",
	"./vencedoresdetarqui": "bde2",
	"./vencedoresdetarqui.js": "bde2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf80";